<script>import "./CarbonChartsStyles.css";
import { DonutChart } from "@carbon/charts-svelte";
export let data;
export let title = "";
export let height;
export let legendPosition = "bottom";
export let getChartsSharedOptions;
let specificOptions = {
  legend: {
    alignment: "center",
    clickable: false,
    position: legendPosition
  },
  donut: {
    alignment: "center"
  },
  toolbar: {
    enabled: false
  },
  tooltip: { truncation: { numCharacter: Infinity } }
};
$: options = { ...specificOptions, ...getChartsSharedOptions(data, title, height) };
</script>

<div>
	<svelte:component this={DonutChart} {data} {options} />
</div>

<style>div :global(.donut-figure){display:none}</style>
